/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M.2197 17.2498c.0001 0 0 .0001 0 0a.7503.7503 0 0 0-.0001 1.0609.7502.7502 0 0 0 1.0607 0c.0002-.0002-.0002.0002 0 0L12 7.591l10.7197 10.7197a.75.75 0 0 0 1.0606-1.0607L12 5.4697.2197 17.2498Z"
    clipRule="evenodd"
  />,
  'ChevronUp'
);
